import PropTypes from 'prop-types'

const FieldSearch = ({
                         id,
                         type,
                         placeholder,
                         iconBefore,
                         iconAfter,
                         wrapperClasses,
                         inputClasses,
                         field,
                         max,
                         disabled,
                         readOnly,
                         form: {touched, errors}
                     }) => {
    return (
        <div className={wrapperClasses}>
            <div className="field input-group flex border border-gray-400">
                {iconBefore &&
                    <span
                        className="flex items-center justify-center text-gray-400">
                   {iconBefore}
                </span>
                }
                <input
                    value={field.value}
                    id={id}
                    type={type}
                    disabled={!!disabled}
                    max={max}
                    className={`w-full  py-1  text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded-md mr-2` + inputClasses}
                    placeholder={placeholder}
                    {...field}
                    readOnly={readOnly}
                />
                {iconAfter &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                    {iconAfter}
                </span>
                }
            </div>
            {touched[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }
        </div>
    )
}

export default FieldSearch

FieldSearch.propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    field: PropTypes.object,
    form: PropTypes.object,
    max: PropTypes.string,
    disabled: PropTypes.bool,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
    readOnly: PropTypes.bool
}

